import { useEffect, useState } from "react";
import BlogPageLayout from "../BlogPageLayout"
import CapitulosPreview from "./CapitulosPreview"
import { useParams } from "react-router-dom";
import apiSafibc from "../../../axios/axios";


const TemplateCapitulo = () => {


    const { slug } = useParams();
    const [data, setData] = useState(null);


    useEffect(() => {
        const obtener = async () => {
            try {
                const res = await apiSafibc(`/blog/obtener-capitulos`);

                // buscas el capítulo por slug
                const capitulo = res.data.find(c => c.slug === slug);
                setData(capitulo);

            } catch (error) {
                console.error(error);
            }
        };

        obtener();
    }, [slug]);

    if (!data) return <div>Cargando...</div>;

    const formatearFecha = (fecha) => {
        return new Date(fecha).toLocaleDateString('es-MX', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });
    };

    return (
        <BlogPageLayout
            titulo={data.titulo}
            autor={data['autor.nombre_usuario']}
            fecha={formatearFecha(data.publicado)}
            articulo='true'
        >
            <div className="container-fluid animation">
                <div className="row d-flex justify-content-center">
                    <article className="col-10 col-md-8 inicio-title inicio-text-parrafo">
                        <div style={{ textAlign: 'justify' }} className="">
                            <div dangerouslySetInnerHTML={{ __html: data.contenido }} />

                        </div>


                        <CapitulosPreview />
                    </article>
                </div>
            </div>

        </BlogPageLayout>
    )
}

export default TemplateCapitulo